import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-line\"><defs><style type=\"text/css\"></style></defs><path d=\"M320 352H64v480h256V352z m-64 416H128V416h128v352zM640 64H384v768h256V64z m-64 704H448V128h128v640zM64 896h896v64H64z m640-64h256V224H704v608z m64-544h128v480H768V288z\" fill=\"#333333\" p-id=\"5293\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol